import { AlertContextType } from "../contexts/AlertContext";

let globalAlertContext: AlertContextType | null = null;

export const registerGlobalAlert = (context: AlertContextType) => {
  globalAlertContext = context;
};

export const showAlertModal = (
  message: string,
  title: string = "Hinweis",
  closeButtonText: string = "Schließen",
) => {
  if (globalAlertContext) {
    globalAlertContext.showAlertModal(message, title, closeButtonText);
  } else {
    alert(`${title}: ${message}`);
  }
};

export const showAlert = (
  message: string,
  variant: "danger" | "warning" | "info" | "success" = "danger",
) => {
  if (globalAlertContext) {
    globalAlertContext.showAlert(message, variant);
  } else {
    alert(message);
  }
};
